export const moneyFormatter = (
  locale: string = 'es-CL',
  currency: string = 'CLP',
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const checkCurrencyAsNumber = (value: string) => {
  const isDecimal = typeof value === 'string' && value.includes(',');
  const hasMultipleCommas =
    typeof value === 'string' && (value.match(/,/g) || []).length > 1;
  let numberValue: number;

  if (typeof value === 'string') {
    if (isDecimal && !hasMultipleCommas) {
      numberValue = Number(
        value
          .replace(/[^\d,]/g, '')
          .split(',')
          .join('.'),
      );
    } else {
      numberValue = Number(value.replace(/\D/g, ''));
    }
  } else {
    numberValue = value;
  }
  return numberValue;
};

export const TariffFormatter = (
  value?: number | string,
  data?: {
    id: number;
    currency: string;
    locale: string;
  },
  defaultValue = '',
) => {
  if (value || value === 0) {
    const isDecimal = typeof value === 'string' && value.includes(',');
    const isCommaAtEnd = typeof value === 'string' && value.endsWith(',');
    const hasMultipleCommas =
      typeof value === 'string' && (value.match(/,/g) || []).length > 1;
    let isZeroAfterComma = false;
    let numberValue: number;

    if (typeof value === 'string') {
      if (isDecimal && !hasMultipleCommas) {
        const afterComma = value.split(',')[1];
        isZeroAfterComma = afterComma === '0';
        numberValue = Number(
          value
            .replace(/[^\d,]/g, '')
            .split(',')
            .join('.'),
        );
      } else {
        numberValue = Number(value.replace(/\D/g, ''));
      }
    } else {
      numberValue = value;
    }
    const formattedValue = moneyFormatter(data?.locale, data?.currency).format(
      numberValue,
    );

    let concatenatedFormattedValue = formattedValue;

    if (isCommaAtEnd) {
      concatenatedFormattedValue += ',';
    } else if (isZeroAfterComma) {
      concatenatedFormattedValue += ',0';
    }

    return concatenatedFormattedValue;
  }
  return defaultValue;
};

export const formatToOnlyPositiveIntegers = (value: string) => {
  if (!isNaN(Number(value))) {
    return value;
  }
  let amount: string | number = value.replace(/\D/g, '').trim();

  if (!amount?.trim()) {
    return '0';
  }

  amount = parseInt(amount);
  if (amount < 1) {
    return '0';
  }

  return `${amount}`;
};

export const formatToOnlyPositiveScaledIntegers = (value: string) => {
  let salary: string | number = value.replace(/\D/g, '').trim();

  if (!salary?.trim()) {
    return '';
  }

  salary = parseInt(salary);
  if (salary < 1) {
    return '';
  }

  if (`${salary}`?.length === 1) {
    return `0,0${salary}`;
  }

  if (`${salary}`?.length === 2) {
    return `0,${salary}`;
  }

  const integers = `${salary}`?.slice(0, `${salary}`?.length - 2);
  const decimals = `${salary}`?.slice(-2);

  return `${integers},${decimals}`;
};
